import React from "react";
import { destroyAsset, uploadAsset } from "../../../actions/roblox/assetsActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewParams } from "../../../store/roblox/assetsSlice";

import DrawerRight from "../../../componets/DrawerRight";
import GroupUpload from "../../../componets/FileDropzone/GroupUpload";
import robloxApi from "../../../api/robloxApi";
import { message, Select } from "antd";
import { EntityId } from "@reduxjs/toolkit";
import { filterOption } from "../../../helpers/FormHelper";
import { selectCategoryEntities, selectCategoryIds } from "../../../store/roblox/categoriesSlice";

const New = () => {
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.roblox.assets.newParams);
  const categories = useAppSelector(selectCategoryEntities);
  const categoryIds = useAppSelector(selectCategoryIds);

  function onClose() {
    dispatch(setNewParams(null));
  }

  function handleUploadSuccess(response: any) {
    dispatch(uploadAsset(response));
  }

  function onClickDestroy(file: any) {
    const id = file.response?.asset?.id;
    if (id) {
      handleDestroy(id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAsset(id));

    if (destroyAsset.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyAsset.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  function onChangeCategory(value: any) {
    const params = { ...newParams };

    if (value === undefined) {
      delete params.category_id;
    } else {
      params.category_id = value;
    }

    dispatch(setNewParams(params));
  }

  const renderCategoryOption = (id: EntityId) => {
    const item = categories[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.name}>{item.name}</Select.Option>
  }

  const renderCategories = () => {
    if (!newParams) {
      return null;
    }

    return (
      <Select
        allowClear
        showSearch
        filterOption={filterOption}
        placeholder='Select a category'
        onChange={onChangeCategory}
        style={{ width: '100%', marginBottom: 20 }}
        defaultValue={newParams.category_id}
      >
        {categories && categoryIds.map(renderCategoryOption)}
      </Select>
    )
  }

  return (
    <DrawerRight
      open={!!newParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-asset'>
        <h6 className="v-content-label">Create Asset</h6>

        {renderCategories()}

        <GroupUpload
          name='item'
          action={robloxApi.oneSky.url('/onesky/assets')}
          headers={robloxApi.oneSky.uploadHeaders}
          data={{ category_id: newParams?.category_id }}
          onSuccess={handleUploadSuccess}
          listType='picture'
          onRemove={onClickDestroy}
        />
      </div>
    </DrawerRight>
  )
}

export default New;
